import React from "react";
import { Container, Row } from "react-bootstrap";
import NewProjectForm from "../../../components/Forms/NewProjectForm";

//  Components
import ProjectBox from "../../../components/ProjectBox";
import useAdminData from "../../../hooks/useAdminData";

const ProjectsTab = ({ projects }) => {
    const { error } = useAdminData();
    const refresh = () => {
        window.location.reload();
    };
    return (
        <Container className="mb-3">
            <h4>
                My projects{" "}
                <i
                    className="fas fa-redo-alt fs-5 text-danger"
                    onClick={refresh}
                ></i>
            </h4>

            <Row className="mb-4">
                {!error &&
                    projects.map((project, i) => {
                        return (
                            <ProjectBox
                                project={project}
                                index={i}
                                key={`p-${i}`}
                            />
                        );
                    })}
                {error && <p>⚠️ Error while trying to load the projects.</p>}
            </Row>

            <h4>New project</h4>
            <NewProjectForm />
        </Container>
    );
};

export default ProjectsTab;
